module["exports"] = ["br", "com", "biz", "info", "name", "net", "org"];